var _linearGradient, _path, _linearGradient2, _circle, _linearGradient3, _path2, _path3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _path7, _linearGradient6, _path8, _linearGradient7, _path9, _path10, _linearGradient8, _path11, _linearGradient9, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: -5347.366,
    y1: -9.196,
    x2: -5346.366,
    y2: -9.196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M51.687 84.258V71.466h94.979v12.792"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: 88.796,
    y1: 30.406,
    x2: 108.675,
    y2: 30.406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.736,
    cy: 30.406,
    r: 8.69,
    fill: "none",
    stroke: "url(#SVGID_1_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: 82.529,
    y1: 45.894,
    x2: 114.943,
    y2: 45.894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.779 52.69c.725-7.626 7.147-13.591 14.962-13.591 7.778 0 14.176 5.908 14.952 13.481",
    fill: "none",
    stroke: "url(#SVGID_2_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M98.847 58.371v25.887"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M154.24 96.312v4.474M152.055 107.032h-10.806"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: 134.651,
    y1: 115.277,
    x2: 158.681,
    y2: 115.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M157.431 105.153V125.4h-21.53v-20.247"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: -2952.582,
    y1: -2254.304,
    x2: -2928.584,
    y2: -2254.304,
    gradientTransform: "rotate(45.001 -4249.599 2654.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M131.453 108.92l15.224-15.225 15.202 15.202"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M106.601 96.312v4.474M104.416 107.032H93.611"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: 87.013,
    y1: 115.277,
    x2: 111.043,
    y2: 115.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M109.793 105.153V125.4H88.262v-20.247"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: -2986.268,
    y1: -2220.619,
    x2: -2962.269,
    y2: -2220.619,
    gradientTransform: "rotate(45.001 -4249.599 2654.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M83.815 108.92l15.224-15.225 15.201 15.202"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M59.695 96.312v4.474M57.511 107.032H46.705"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: 40.107,
    y1: 115.277,
    x2: 64.137,
    y2: 115.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M62.887 105.153V125.4h-21.53v-20.247"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69",
    gradientUnits: "userSpaceOnUse",
    x1: -3019.436,
    y1: -2187.451,
    x2: -2995.437,
    y2: -2187.451,
    gradientTransform: "rotate(45.001 -4249.599 2654.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_5a97ad535d81c2d14c83a73887fa147dc6a051338586596a806b27f62b403d69)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M36.909 108.92l15.224-15.225 15.202 15.202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyRoles);
export default __webpack_public_path__ + "static/media/companyRoles.28f6751ad427849e658acdf6c34acb08.svg";
export { ForwardRef as ReactComponent };